import * as React from 'react';
import { QuestionnaireSectionCreateInput, QuestionnaireSectionUpdateInput } from '../generated/globalTypes';
import { useSaveInStore, SaveInStoreOptions } from '../../../shared/useSaveInStore';
import { useCreateQuestionnaireSectionCallback } from './useCreateQuestionnaireSectionCallback';
import { useUpdateQuestionnaireSectionCallback } from './useUpdateQuestionnaireSectionCallback';
import { QuestionnaireSection } from '../models/QuestionnaireSection';

/**
 * Get a callback to save a QuestionnaireSection in the store using either a create or update.
 */
export function useSaveQuestionnaireSectionCallback(options: SaveInStoreOptions<QuestionnaireSection, string> = {}) {
    const [_create, createStatus] = useCreateQuestionnaireSectionCallback();
    const create = React.useCallback((model: Partial<QuestionnaireSection>) => _create(model as QuestionnaireSectionCreateInput), [_create]);

    const [_update, updateStatus] = useUpdateQuestionnaireSectionCallback();
    const update = React.useCallback((id: string, changes: Partial<QuestionnaireSection>) => _update(id, changes as QuestionnaireSectionUpdateInput), [_update]);

    return useSaveInStore(
        [create, createStatus],
        [update, updateStatus],
        options
    );
}
